export const SET_THEME = 'SET_THEME';

export const setTheme = (theme) => ({ 
    type: SET_THEME,
    payload: theme, 
  });

  export const setCustomTheme = (colorHex) => ({
    type: "SET_CUSTOM_THEME",
    payload: colorHex,
  });